export default "__VITE_ASSET__CPBprpcg__"